import React from 'react';
import ApplyLoanTable from './ApplyLoan/ApplyLoanTable';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function ApplyLoan() {
  

        const Navigate =  useNavigate()
 
       

  return (
    <div className="min-h-screen w-full flex flex-col items-center bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 py-10 px-4">
      
      {/* Header Section */}
      <div className="text-center mb-10">
        <h1 className="text-2xl font-serif md:text-4xl font-extrabold text-slate-800 tracking-wide mb-2">
          Partner Bank (s)
        </h1>
        <p className="text-slate-500 text-sm md:text-base max-w-xl mx-auto">
          Explore eligible loan programs tailored to your qualification and residence type.  
          Review details carefully before applying.
        </p>
      </div>

      {/* Card Container */}
      <div className="w-full md:w-5/6 lg:w-3/4 xl:w-2/3 bg-white/80 backdrop-blur-sm shadow-xl rounded-2xl p-4 sm:p-6 md:p-8">
        <ApplyLoanTable />

          <div className="p-7 text-center"><Button onClick={()=>Navigate("/application/my_application")} variant="contained">Final</Button> step, my application</div>
      </div>

      {/* Footer Section (optional) */}
      <div className="mt-10 text-center text-slate-400 text-xs md:text-sm">
        Powered by <span className="font-semibold text-slate-600">MastermindTech</span>
      </div>
    </div>
  );
}

export default ApplyLoan;
